import React from "react";
import { observer } from "mobx-react-lite";
import { useGlobalStore } from "@/store/hooks";

interface ShipperColumnProps {
    shippingAddressId: number;
}

const ShipperColumn: React.FC<ShipperColumnProps> = function ({ shippingAddressId }) {
    const globalStore = useGlobalStore();

    const shippingAddress = globalStore.waybillPrintStore.shippingAddressMapping.get(shippingAddressId);

    if (!shippingAddress) return <td />;

    return <td>{shippingAddress.shipperName || shippingAddress.name}</td>;
};

export default observer(ShipperColumn);
